// VITE_BACKEND_BASE_URL already includes the /api/v1 base path, so endpoint
// paths must be relative to it (matching customerPurgeEndpoints).
const kybEndpoints = {
  openOrGetCase: () => `/compliance/kyb/legal-entity-cases`,
  documentChecklist: (caseId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/documents`,
  documentChecklistItem: (caseId: string, caseDocumentId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/documents/${caseDocumentId}`,
  documentUpload: (caseId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/documents/upload`,
  documentDownload: (caseId: string, personDocumentId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/documents/${personDocumentId}/download`,
  entityRegistrations: (caseId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/registrations`,
  entityRegistration: (caseId: string, registrationId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/registrations/${registrationId}`,
  entityRegistrationVerification: (caseId: string, registrationId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/registrations/${registrationId}/verification`,
  entityRegistrationProof: (caseId: string, registrationId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/registrations/${registrationId}/proof`,
  entityRegistrationHistory: (caseId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/registrations/historique`,
  relationRoles: (ecran?: "REPRESENTANTS" | "ACTIONNARIAT_UBO") =>
    ecran
      ? `/compliance/kyb/relation-roles?ecran=${ecran}`
      : `/compliance/kyb/relation-roles`,
  representatives: (caseId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/representatives`,
  representativeCandidates: (
    caseId: string,
    lastName: string,
    firstName: string,
    birthDate?: string,
  ) => {
    const params = new URLSearchParams({ lastName, firstName });
    if (birthDate) {
      params.set("birthDate", birthDate);
    }
    return `/compliance/kyb/legal-entity-cases/${caseId}/representatives/candidates?${params.toString()}`;
  },
  representativeRoles: (caseId: string, relatedPersonId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/representatives/${relatedPersonId}/roles`,
  representativeRole: (
    caseId: string,
    relatedPersonId: string,
    personRoleId: string,
  ) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/representatives/${relatedPersonId}/roles/${personRoleId}`,
  ownershipLegalParties: (caseId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/ownership/legal-parties`,
  ownershipEdges: (caseId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/ownership/edges`,
  ownershipEdge: (caseId: string, ownershipEdgeId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/ownership/edges/${ownershipEdgeId}`,
  ownershipBeneficialOwners: (caseId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/ownership/ubo`,
  ownershipOpacity: (caseId: string) =>
    `/compliance/kyb/legal-entity-cases/${caseId}/ownership/opacity`,
};

export default kybEndpoints;
